import products from './products-reducer';

export * from './products-reducer';
export default products;
